import { render, staticRenderFns } from "./MusicItem.vue?vue&type=template&id=190a0736&"
import script from "./MusicItem.vue?vue&type=script&lang=ts&"
export * from "./MusicItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports